
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Créer sa fiche d'entreprise sur Google : guide étape par étape",
    description:
      "Apprenez à créer votre fiche d'entreprise sur Google pour améliorer votre visibilité locale et attirer des clients grâce à des informations précises et complètes.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
